import { connect } from "react-redux";
import { bindActionCreators } from "redux";
// actions
import { offersActionCreators } from "../../../common/store/modules/offersModule";
// helpers
import { generateUniqueId } from "../../../common/utils/panel-helpers/helpers";
import { getCheckedCategoryIds, offersStep, tooltip, updateCategoryIds } from "../offersHelpers";
// components
import { CustomFormInput } from "@gl-shared/shared/ui";
import { CustomFormTextArea } from "@gl-shared/shared/ui";
import { CustomCheckbox } from "@gl-shared/shared/ui";
import { CustomTooltip } from "@gl-shared/shared/ui";
// icons
import { addIcon, removeIcon } from "@gl-shared/shared/vector";

const offerDetailsStep = offersStep.offerDetails;

const OfferDetailsStep = props => {
  const checkedCategoryIds = getCheckedCategoryIds(props.hotelEventCategories, props.offerDetailsData.event_categories);

  const durationOnKeyDown = event => {
    if (event.key === ".") {
      event.preventDefault();
    }
  };

  const durationOnInput = event => (event.target.value = event.target.value.replace(/[^0-9]*/g, ""));

  const handleLinkLabel = (event, linkId) => {
    props.updateStepAction(offerDetailsStep, {
      ...props.offerDetailsData,
      links: props.offerDetailsData?.links?.map(link =>
        link?.id === linkId ? { ...link, label: event.target.value } : link
      )
    });
  };

  const handleLinkUrl = (event, linkId) => {
    props.updateStepAction(offerDetailsStep, {
      ...props.offerDetailsData,
      links: props.offerDetailsData?.links?.map(link =>
        link?.id === linkId ? { ...link, url: event.target.value } : link
      )
    });
  };

  return (
    <div className="row details-step">
      <div className="col-lg-6 left-side">
        <CustomFormInput
          name="offer_name"
          id="offer_name"
          label="Offer Name"
          tooltipTitle={tooltip.offerName}
          value={props.offerDetailsData?.name}
          onInputChange={event =>
            props.updateStepAction(offerDetailsStep, { ...props.offerDetailsData, name: event.target.value })
          }
          errorField={props.errorField}
          isRequired={true}
          alignRow={true}
        />
        <CustomFormInput
          type="number"
          min={0}
          step={1}
          onKeyDown={durationOnKeyDown} // disable decimal numbers
          onInput={durationOnInput} // disable decimal numbers
          name="duration"
          id="duration"
          label="Duration in minutes"
          tooltipTitle={tooltip.duration}
          value={props.offerDetailsData?.duration_in_minutes}
          onInputChange={event =>
            props.updateStepAction(offerDetailsStep, {
              ...props.offerDetailsData,
              duration_in_minutes: event.target.value
            })
          }
          errorField={props.errorField}
          alignRow={true}
        />
        <div className="form-group row">
          <label className="col-sm-4 col-form-label">
            Category<span className="mandatory-star">*</span>
            <span className="label-tooltip">
              <CustomTooltip title={tooltip.categories} placement="right-start" />
            </span>
          </label>

          <div className="col-sm-8">
            {props.hotelEventCategories?.map(category => {
              return (
                <div key={category.id} className="form-group__details-checkbox">
                  <CustomCheckbox
                    label={category.display_name}
                    labelClass="form-group__details-checkbox__label"
                    isChecked={!!checkedCategoryIds.find(catId => category.id === catId)}
                    value={!!checkedCategoryIds.find(catId => category.id === catId)}
                    iconSize={20}
                    onClick={() =>
                      props.updateStepAction(offerDetailsStep, {
                        ...props.offerDetailsData,
                        event_categories: updateCategoryIds(category.id, checkedCategoryIds)
                      })
                    }
                  />
                </div>
              );
            })}
            <div className="form-group__error-message">
              {props.errorField?.event_categories ? "You need to select at least one category" : ""}
            </div>
          </div>
        </div>
      </div>
      <div className="col-lg-6 right-side">
        <CustomFormTextArea
          name="short_description"
          id="short_description"
          label="Short Description"
          tooltipTitle={tooltip.shortDescription}
          value={props.offerDetailsData.short_description || ""}
          isRequired={true}
          onChange={event =>
            props.updateStepAction(offerDetailsStep, {
              ...props.offerDetailsData,
              short_description: event.target.value
            })
          }
          errorField={props.errorField}
        />
        <CustomFormTextArea
          name="long_description"
          id="long_description"
          label="Long Description"
          tooltipTitle={tooltip.longDescription}
          value={props.offerDetailsData.long_description || ""}
          isRequired={true}
          onChange={event =>
            props.updateStepAction(offerDetailsStep, {
              ...props.offerDetailsData,
              long_description: event.target.value
            })
          }
          errorField={props.errorField}
          textareaRows={7}
          bigTextarea={true}
        />
        <CustomFormTextArea
          name="post-booking"
          label="Post Booking Info"
          tooltipTitle={tooltip.postBookingInfo}
          value={props.offerDetailsData.post_booking_info || ""}
          onChange={event =>
            props.updateStepAction(offerDetailsStep, {
              ...props.offerDetailsData,
              post_booking_info: event.target.value
            })
          }
          errorField={null}
        />
        <CustomFormTextArea
          name="cancellation-policy"
          label="Cancellation policy"
          tooltipTitle={tooltip.cancellation}
          value={props.offerDetailsData.cancellation_policy || ""}
          onChange={event =>
            props.updateStepAction(offerDetailsStep, {
              ...props.offerDetailsData,
              cancellation_policy: event.target.value
            })
          }
          errorField={null}
        />
      </div>
      <div className="col-sm-12 mb-5 details-step__links">
        <label className="col-form-label">
          Links
          <span className="label-tooltip">
            <CustomTooltip title={tooltip.links} placement="right-start" />
          </span>
        </label>

        <div className="col-sm-6 mt-2">
          {props.offerDetailsData?.links?.length > 0 ? (
            props.offerDetailsData?.links?.map((link, i) => {
              return (
                <div
                  className={`row ${i < props.offerDetailsData?.links?.length && "details-step__links__row-divider"}`}
                  key={link?.id}
                >
                  <div className="col-sm-11">
                    <CustomFormInput
                      name={`link_label_${link?.id}`}
                      id={`link_label_${link?.id}`}
                      label="Label"
                      value={link?.label}
                      onInputChange={event => handleLinkLabel(event, link?.id)}
                      errorField={props.errorField}
                      alignRow={true}
                      showTooltip={false}
                      isRequired={true}
                    />
                    <CustomFormInput
                      name={`link_url_${link?.id}`}
                      id={`link_url_${link?.id}`}
                      label="URL"
                      value={link?.url}
                      onInputChange={event => handleLinkUrl(event, link?.id)}
                      errorField={props.errorField}
                      alignRow={true}
                      showTooltip={false}
                      isRequired={true}
                    />
                  </div>
                  <div className="col-sm-1 details-step__links__remove-icon">
                    <CustomTooltip title={"Remove link"} placement="right-start">
                      <img
                        src={removeIcon}
                        alt="remove-button-icon"
                        onClick={() => {
                          props.updateStepAction(offerDetailsStep, {
                            ...props.offerDetailsData,
                            links: props.offerDetailsData?.links?.filter(rmvLink => rmvLink?.id !== link?.id)
                          });
                        }}
                      />
                    </CustomTooltip>
                  </div>
                </div>
              );
            })
          ) : (
            <div className="mb-3">Here you can add related links for the offer</div>
          )}

          <div className="details-step__links__add-icon">
            <CustomTooltip title={"Add link"} placement="right-start">
              <img
                src={addIcon}
                alt="add-button-icon"
                onClick={() => {
                  props.updateStepAction(offerDetailsStep, {
                    ...props.offerDetailsData,
                    links: [...props.offerDetailsData?.links, { url: "", label: "", id: generateUniqueId() }]
                  });
                }}
              />
            </CustomTooltip>
          </div>
        </div>
      </div>
    </div>
  );
};

const mapStateToProps = state => ({
  offerDetailsData: state.offers.offerDetailsData
});

const mapDispatchToProps = dispatch => {
  return bindActionCreators(
    {
      updateStepAction: offersActionCreators.updateStepAction
    },
    dispatch
  );
};

export default connect(mapStateToProps, mapDispatchToProps)(OfferDetailsStep);
